import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR } = theme.mixins;
  return {
    listingLayoutWrappeer: {
      paddingTop: pxToRem(48),
      paddingBottom: pxToRem(48),
      background: theme.mixins.White(),


      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        padding: `${pxToRem(5)} 5.5% ${theme.spacing(11)} 5.5%`,
        margin: 0,
      },
    },
    filterSection: {
      [theme.breakpoints.up('lg')]: {
        flexBasis: '25%',
      },
      [theme.breakpoints.down('lg')]: {
        '& section': {
          transform: 'none',
        },
      },
    },
    filterdList: {
      overflowAnchor: 'none',
      [theme.breakpoints.up('lg')]: {
        flexBasis: '75%',
        ...marginLR(pxToRem(24), 0),
      },
    },
  };
});

export default useStyles;
